import { Nullable } from '@/shared/types/app.types'
import { ICellEditorParams } from '@ag-grid-enterprise/all-modules'

export interface NumericCellEditorParams extends ICellEditorParams {
    value: number
    max?: number
    min?: number
    step?: number
}

export interface NumericCellEditorState {
    value: Nullable<number>
}
export const initialNumericCellEditorState =
    (): NumericCellEditorState => ({
        value: null
    })
